import { Button } from '@mantine/core';
import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import type { CustomerThreadKind } from './threadLabels';

/**
 * Opens a new message to Rethink (the new-message page) with its kind and
 * subject filled in, and the deployment it is about when `environmentId` is
 * set. `primary` is the page's main action.
 */
export function ComposeButton({
  kind,
  subject,
  environmentId,
  primary = false,
  children,
}: {
  kind: CustomerThreadKind;
  subject: string;
  environmentId?: string;
  primary?: boolean;
  children: ReactNode;
}) {
  return (
    <Button
      renderRoot={(props) => (
        <Link {...props} to="/messages/new" search={{ kind, subject, environmentId }} />
      )}
      variant={primary ? 'filled' : 'default'}
      h={40}
    >
      {children}
    </Button>
  );
}
